import { BackendEvent, EventSDK, MediaStreamSDK } from "media-stream-sdk";
import { useEffect, useRef, useState } from "react";
import MessageComponent from "./MessageComponent";

const MainComponent = () => {
  const [isCalling, setIsCalling] = useState(false);
  const sdkRef = useRef<MediaStreamSDK | null>(null);
  const loggingSdkRef = useRef<EventSDK | null>(null);
  const [messages, setMessages] = useState<Array<BackendEvent>>([]);
  const [showCloseCallMessage, setShowCloseCallMessage] = useState(false);

  const closeCallMessage =
    process.env.REACT_APP_CLOSE_CALL_MESSAGE ??
    "Remember to close the call after use.";

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sdkRef.current) {
        sdkRef.current.destroyWebSocketConnection();
        console.log("WebSocket closed after 15 minutes.");
      }
    }, 15 * 60 * 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!sdkRef.current) {
    sdkRef.current = new MediaStreamSDK(
      {
        websocketUrl: process.env.REACT_APP_MEDIA_STREAM_WS_URL,
        streamSid: "1234567890",
      },
      {
        onError: (error: Error) => console.error("Error:", error),
        onClose: () => console.log("WebSocket closed."),
      }
    );
  }

  if (!loggingSdkRef.current) {
    loggingSdkRef.current = new EventSDK(
      process.env.REACT_APP_FRONTEND_LOGGING_WS_URL ?? ""
    );

    loggingSdkRef.current.onBackendEventReceived = (message: BackendEvent) => {
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          type: message.type,
          content: message.content,
          timestamp: message.timestamp,
        },
      ]);
    };
  }

  const startCall = async () => {
    if (isCalling || !sdkRef.current || !loggingSdkRef.current) return;
    setIsCalling(true);
    setShowCloseCallMessage(true);
    try {
      await sdkRef.current.startConversation();
      loggingSdkRef.current.connect();
    } catch (e) {
      console.error(e);
      setIsCalling(false);
      setShowCloseCallMessage(false);
    } finally {
      setMessages([]);
    }
  };

  const endCall = () => {
    if (!isCalling || !sdkRef.current) return;
    setIsCalling(false);
    setShowCloseCallMessage(false);
    try {
      sdkRef.current?.stopConversation();
      loggingSdkRef.current?.destroyWebSocketConnection();
    } catch (error) {
      console.error(error);
      setIsCalling(true);
      setShowCloseCallMessage(true);
    }
  };
  return (
    <div className="app-container">
      <header className="topbar">
        <div className="brand">
          <span className="brand-dot" />
          <h1>GAIA HD Assistant</h1>
        </div>
        <div className={`status-badge ${isCalling ? "active" : "idle"}`}>
          {isCalling ? "Live" : "Idle"}
        </div>
      </header>
      <main className="content">
        {showCloseCallMessage && (
          <div className="close-call-message">{closeCallMessage}</div>
        )}
        <div className="controls">
          <button
            className="button primary"
            id="startCall"
            onClick={startCall}
            disabled={isCalling}
          >
            Start Call
          </button>
          <button
            className="button"
            id="endCall"
            onClick={endCall}
            disabled={!isCalling}
          >
            End Call
          </button>
        </div>
        <div className="messages-panel">
          <MessageComponent messages={messages} />
        </div>
      </main>
    </div>
  );
};

export default MainComponent;
